import React, { useState } from "react";
import { toast } from "sonner";
import { adminApi, apiError } from "@/admin/adminApi";
import { PageHead } from "@/admin/AdminLayout";
import { btnPrimary, card, fieldInput, fieldLabel } from "@/admin/ui";

export default function AdminSettings() {
  const [form, setForm] = useState({ current: "", next: "", repeat: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 10) return toast.error("Az új jelszó legalább 10 karakter legyen.");
    if (form.next !== form.repeat) return toast.error("A két új jelszó nem egyezik.");
    setSaving(true);
    try {
      await adminApi.post("/admin/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("A jelszó módosítva.");
      setForm({ current: "", next: "", repeat: "" });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-settings-page">
      <PageHead eyebrow="Beállítások" title="Jelszó módosítása" />
      <form onSubmit={submit} className={`${card} px-6 md:px-8 py-7 max-w-md space-y-5`} data-testid="password-form">
        <div>
          <label className={fieldLabel} htmlFor="pw-current">Jelenlegi jelszó</label>
          <input id="pw-current" type="password" required autoComplete="current-password" value={form.current} onChange={set("current")} data-testid="password-current" className={fieldInput} />
        </div>
        <div>
          <label className={fieldLabel} htmlFor="pw-next">Új jelszó (legalább 10 karakter)</label>
          <input id="pw-next" type="password" required autoComplete="new-password" value={form.next} onChange={set("next")} data-testid="password-new" className={fieldInput} />
        </div>
        <div>
          <label className={fieldLabel} htmlFor="pw-repeat">Új jelszó még egyszer</label>
          <input id="pw-repeat" type="password" required autoComplete="new-password" value={form.repeat} onChange={set("repeat")} data-testid="password-repeat" className={fieldInput} />
        </div>
        <button type="submit" disabled={saving} className={btnPrimary} data-testid="password-save">{saving ? "Mentés…" : "Jelszó mentése"}</button>
      </form>
    </div>
  );
}
